module.exports = __webpack_public_path__ + "img/android2.a8631a75.png";